export const SALES_BY_EMPLOYEE_FIELD_TOOLTIPS = {
  start_date: "First day to include in the report (based on your salon's timezone).",
  end_date: "Last day to include in the report (based on your salon's timezone).",
  group_by:
    "Choose how results are grouped (by employee, day, category, service/product, or payment type).",
  employees:
    "Select which employees to include (leave all selected to include everyone).",
  revenue_types:
    "Choose what to count as sales in this report (services, retail, gift cards).",
  payment_types:
    "Choose which payment methods to include in totals (cash, card, gift card, other).",
  ticket_status:
    "Closed Only is recommended for accounting reports; Open includes unfinished tickets.",
  minimum_amount:
    "Show only rows where net sales are at least this amount (example: 50).",
  search: "Search clients by name, email, or phone to narrow results.",
  include_tips: "Adds tip amounts to the report totals and rows.",
  include_taxes: "Includes tax amounts in totals and gross calculations.",
  include_refunds: "Includes refunds and allows refund totals/rates in rows.",
  run_report: "Refresh the results using the selected filters.",
  export_csv: "Download the current results (with the same filters and sorting).",
};
